module.exports = __webpack_public_path__ + "img/tesla-promotion.c7607757.png";